import React, {ReactNode,} from "react";
import '../../styles/components/lesson/control-bar-dropdown.scss';

interface IControlBarDropDownProps<TOptionValueType> {
  children?: ReactNode;
  isDropdownMenuOpen: boolean;
  changeDropdownMenuOpen: (isOpen: boolean) => void;
  iconElement: ReactNode;
  additionalCssClassName?: string;
  tooltip?: string;
  ariaLabel?: string;
  disabled?: boolean;
}

export default function ControlBarDropDown<TOptionValueType>({
  isDropdownMenuOpen,
  changeDropdownMenuOpen,
  children,
  iconElement,
  additionalCssClassName,
  tooltip,
  ariaLabel,
  disabled,
}: IControlBarDropDownProps<TOptionValueType>) {
  const openClass = isDropdownMenuOpen ? "open" : "";
  const additionalClassName = additionalCssClassName ? additionalCssClassName : "";
  const menuContainerId = `controlBarDropDownSelector`;
  const disabledClassName = disabled ? `disabled` : ``;

  const toggleMenu = (event: React.KeyboardEvent) => {
    if (isDropdownMenuOpen && event.code === "Enter") {
      changeDropdownMenuOpen(false)
    }

    if (!isDropdownMenuOpen && event.code === "Enter") {
      changeDropdownMenuOpen(true)
    }
  }

  return (
    <div tabIndex={0} role={"button"} className={`${additionalClassName} control-bar-dropdown-selector ${openClass} ${disabledClassName}`} onKeyDown={toggleMenu} onBlur={(e)=>{
      if(!e.currentTarget.contains(e.relatedTarget as Node)){ //if an input gets focus, blur will get called, so check if the input is inside this element.
        changeDropdownMenuOpen(false);
      }
    }}>
      <div id={menuContainerId} onClick={ (e: React.SyntheticEvent) => handleOutsideOfMenuClick(e, changeDropdownMenuOpen, isDropdownMenuOpen, menuContainerId,) } className={`control-bar-dropdown-background-fullscreen-click-interceptor ${openClass}`}/>
      <div className={`icon-container ${openClass}`} onClick={()=> !disabled && changeDropdownMenuOpen(!isDropdownMenuOpen) } title={tooltip} aria-label={ariaLabel}>{iconElement}</div>
      <div className={`menu-items-dropdown ${openClass}`} >
        {children}
      </div>
    </div>
  );
}

function handleOutsideOfMenuClick(e: React.SyntheticEvent, changeDropdownMenuOpen: (isOpen: boolean) => void, isOpen: boolean, menuContainerId: string){
  //@ts-ignore because i'm not sure which generic to specify for SyntheticEvent<T> which would have a "target" property defined.
  if(isOpen && e.target.id === menuContainerId){
    changeDropdownMenuOpen(false);
  }
}
